module.exports = __webpack_public_path__ + "img/рз_28.3ad40a4a.png";